const apikey = process.env.GATSBY_COUNTRY_ID_APIKEY;

export const GET_CURRENCIES = (countryid) => ({
  url: `https://api.sendity.com/moneytrasfer/currencies/${countryid}`,
  method: "get",
  headers: {
    apikey: apikey,
  },
});

// not used RN, used instead in prebuilb time
export const GET_COUNTRIES = () => ({
  url: `https://api.sendity.com/moneytrasfer/calulator/countries`,
  method: "get",
  headers: {
    apikey: apikey,
  },
});

export const GET_PRODUCTS = (countryid) => ({
  url: `https://api.sendity.com/moneytrasfer/calulator/countries/products/${countryid}`,
  method: "get",
  headers: {
    apikey: apikey,
  },
});

export const GET_MARKUP = () => ({
  url: `https://api.sendity.com/moneytrasfer/calulator/markup`,
  method: "get",
  headers: {
    apikey: apikey,
  },
});
